import React from "react";
import { useTranslation } from "react-i18next";
import {  CiBookmarkPlus } from "react-icons/ci";

import css from "./ButtonDuplicate.module.css";

const ButtonDuplicate = (props) => {
  const { onClick, isOnlyIcon } = props;
  const { t } = useTranslation();

  return (
    <button className={css.wrap} onClick={onClick}>
      {isOnlyIcon ? <></> : <span>{t("button-duplicate-text")}</span>}
      <span className={css.icon}>
        <CiBookmarkPlus />
      </span>
    </button>
  );
};

export { ButtonDuplicate };
